export const studioShellMessagesEs = Object.freeze({
  'studio.navigation.editor': 'Editor',
  'studio.navigation.screens': 'Pantallas',
  'studio.navigation.templates': 'Plantillas',
  'studio.navigation.components': 'Componentes',
  'studio.navigation.aiGenerate': 'Generar con IA',
  'studio.navigation.content': 'Contenido',
  'studio.navigation.models': 'Modelos',
  'studio.navigation.queries': 'Consultas',
  'studio.navigation.forms': 'Formularios',
  'studio.navigation.automations': 'Automatizaciones',
  'studio.navigation.admin': 'Administración',
  'studio.navigation.roles': 'Roles',
  'studio.navigation.media': 'Medios',
  'studio.navigation.extensions': 'Extensiones',
  'studio.navigation.themes': 'Temas',
  'studio.navigation.preview': 'Vista previa',
  'studio.navigation.compatibility': 'Compatibilidad',
  'studio.navigation.export': 'Exportar',
  'studio.navigation.deploy': 'Desplegar',
  'studio.navigation.help': 'Ayuda',
  'studio.navigation.settings': 'Configuración',

  'studio.sidebar.group.build': 'Construir',
  'studio.sidebar.group.data': 'Datos',
  'studio.sidebar.group.logic': 'Lógica',
  'studio.sidebar.group.app': 'App',
  'studio.sidebar.group.resources': 'Recursos',
  'studio.sidebar.group.appearance': 'Apariencia',
  'studio.sidebar.group.publish': 'Publicar',
  'studio.sidebar.item.editor': 'Editor',
  'studio.sidebar.item.screens': 'Pantallas',
  'studio.sidebar.item.components': 'Componentes',
  'studio.sidebar.item.templates': 'Plantillas',
  'studio.sidebar.item.aiGenerate': 'Generar con IA',
  'studio.sidebar.item.records': 'Registros',
  'studio.sidebar.item.models': 'Modelos',
  'studio.sidebar.item.dataSources': 'Fuentes de datos',
  'studio.sidebar.item.queries': 'Consultas',
  'studio.sidebar.item.workflows': 'Acciones y workflows',
  'studio.sidebar.item.state': 'Estado y variables',
  'studio.sidebar.item.forms': 'Formularios',
  'studio.sidebar.item.navigation': 'Navegación',
  'studio.sidebar.item.users': 'Usuarios y permisos',
  'studio.sidebar.item.admin': 'Administración',
  'studio.sidebar.item.media': 'Medios',
  'studio.sidebar.item.extensions': 'Extensiones',
  'studio.sidebar.item.themes': 'Temas',
  'studio.sidebar.item.designSystem': 'Sistema de diseño',
  'studio.sidebar.item.tokens': 'Tokens',
  'studio.sidebar.item.preview': 'Vista previa',
  'studio.sidebar.item.compatibility': 'Compatibilidad',
  'studio.sidebar.item.export': 'Exportar',
  'studio.sidebar.item.deploy': 'Desplegar',

  'studio.appShell.title': 'ElectroCraft Studio',
  'studio.appShell.sidebarLabel': 'Navegación principal del Studio',
  'studio.appShell.navigationLabel': 'Navegación del Studio',
  'studio.appShell.menuLabel': 'Abrir navegación',
  'studio.appShell.menuTitle': 'Navegación',
  'studio.appShell.menuDescription':
    'Navegación global agrupada del Studio. El estado activo y los iconos se mantienen accesibles también en modo compacto.',
  'studio.appShell.closeMenuLabel': 'Cerrar navegación',
  'studio.appShell.collapseSidebarLabel': 'Contraer barra lateral',
  'studio.appShell.expandSidebarLabel': 'Expandir barra lateral',
  'studio.appShell.workspaceLabel': 'Área de trabajo del Studio',
  'studio.appShell.emptyWorkspace': 'Área de trabajo vacía',
  'studio.appShell.statusLabel': 'Estado del Studio',
  'studio.appShell.status.ready': 'Listo',
  'studio.appShell.status.saving': 'Guardando',
  'studio.appShell.status.error': 'Error',
  'studio.appShell.status.blocked': 'Bloqueado',

  'studio.topbar.breadcrumbRoot': 'Studio',
  'studio.topbar.projectsLabel': 'Proyectos',
  'studio.topbar.projectLabel': 'Proyecto local',
  'studio.topbar.save.ready': 'Sin cambios',
  'studio.topbar.save.saving': 'Guardando',
  'studio.topbar.save.error': 'Error de guardado',
  'studio.topbar.save.blocked': 'Bloqueado',
  'studio.topbar.documentLabel': 'Documento',
  'studio.topbar.documentFallback': 'Inicio',
  'studio.topbar.platformLabel': 'Plataforma',
  'studio.topbar.platformValue': 'Web',
  'studio.topbar.breakpointLabel': 'Breakpoint',
  'studio.topbar.breakpoint.mobile': 'Móvil',
  'studio.topbar.breakpoint.tablet': 'Tablet',
  'studio.topbar.breakpoint.laptop': 'Portátil',
  'studio.topbar.breakpoint.desktop': 'Escritorio',
  'studio.topbar.undoLabel': 'Deshacer',
  'studio.topbar.redoLabel': 'Rehacer',
  'studio.topbar.historyUnavailable': 'Historial no disponible en esta ruta',
  'studio.topbar.zoomLabel': 'Zoom',
  'studio.topbar.toolsLabel': 'Abrir herramientas contextuales',
  'studio.topbar.toolsTitle': 'Herramientas contextuales',
  'studio.topbar.toolsDescription':
    'Documento, plataforma, breakpoint, historial y zoom permanecen accesibles sin comprimir el área de trabajo.',
  'studio.topbar.previewLabel': 'Vista previa',
  'studio.topbar.exportLabel': 'Exportar',
  'studio.topbar.localLabel': 'Local',
  'studio.topbar.helpLabel': 'Ayuda',
  'studio.topbar.helpDescription': 'Ayuda persistente del AppShell y sus preferencias de espacio de trabajo.',
  'studio.topbar.closeHelpLabel': 'Cerrar ayuda',
  'studio.topbar.settingsLabel': 'Configuración',
  'studio.topbar.settingsTitle': 'Configuración',
  'studio.topbar.settingsDescription': 'Preferencias del Studio separadas del modelo canónico del proyecto.',
  'studio.topbar.closeSettingsLabel': 'Cerrar configuración',
  'studio.topbar.workspaceSettingsTitle': 'Espacio de trabajo',
  'studio.topbar.sidebarPreferenceLabel': 'Barra lateral',
  'studio.topbar.sidebarExpandedLabel': 'Expandida',
  'studio.topbar.sidebarCollapsedLabel': 'Contraída',
  'studio.topbar.collapseSidebarAction': 'Contraer',
  'studio.topbar.expandSidebarAction': 'Expandir',

  'studio.bootstrap.m03Kicker': 'Studio · F03 / M03.4',
  'studio.bootstrap.foundationSummary':
    'Topbar global de 52px sobre el AppShell: contexto de documento, herramientas responsive, publicación, ayuda persistente y Settings conectado al WorkspacePreferencesPort.',
  'studio.bootstrap.openDesignSystemGallery': 'Abrir galería técnica del sistema de diseño',
  'studio.bootstrap.title': 'ElectroCraft — Desarrollo',
  'studio.bootstrap.environmentStatus': 'Estado del entorno',
  'studio.bootstrap.projectRouteLabel': 'Ruta temporal · /',
  'studio.bootstrap.projectHomeTitle': 'Inicio del proyecto',
  'studio.bootstrap.projectHomeSummary':
    'Esta superficie solo confirma el arranque del Studio; no contiene datos demo permanentes.',
  'studio.bootstrap.routeUnavailableLabel': 'Ruta no disponible en este bootstrap',
  'studio.bootstrap.routeBackTitle': 'Volver a /',
  'studio.bootstrap.routeUnavailableSummary':
    'Las rutas finales pertenecen al modelo de navegación de ElectroCraft y no se duplican aquí.',
  'studio.bootstrap.architectureHelpLabel': 'Ayuda de arquitectura',
  'studio.bootstrap.architectureHelpTitle': 'Arquitectura del repositorio',
  'studio.bootstrap.architectureHelpSummary':
    'Studio es un composition root. El modelo canónico permanece en sus owners y este bootstrap no crea una segunda fuente de verdad.',

  'studio.designSystem.kicker': 'F03 · M03.1 · Ruta interna',
  'studio.designSystem.title': 'Sistema de diseño ElectroCraft',
  'studio.designSystem.summary':
    'Galería técnica temporal para validar tokens, primitives Radix, Lucide, estados, tema y densidad sin adelantar el AppShell de M03.2.',
  'studio.designSystem.themeLabel': 'Tema',
  'studio.designSystem.themeSystem': 'Sistema',
  'studio.designSystem.themeLight': 'Claro',
  'studio.designSystem.themeDark': 'Oscuro',
  'studio.designSystem.primaryAction': 'Acción principal',
  'studio.designSystem.secondaryAction': 'Secundario',
  'studio.designSystem.outlineAction': 'Contorno',
  'studio.designSystem.ghostAction': 'Ligero',
  'studio.designSystem.destructiveAction': 'Eliminar',
  'studio.designSystem.disabledAction': 'Deshabilitado',
  'studio.designSystem.tooltipLabel': 'Ayuda por foco',
  'studio.designSystem.tooltipContent': 'Disponible con puntero y con foco de teclado.',
  'studio.designSystem.dropdownLabel': 'Acciones',
  'studio.designSystem.keyboardFocusTechnicalLabel': 'teclado/foco',
  'studio.designSystem.duplicateAction': 'Duplicar',
  'studio.designSystem.renameAction': 'Renombrar',
  'studio.designSystem.deleteAction': 'Eliminar',
  'studio.designSystem.sheetOpen': 'Abrir inspector',
  'studio.designSystem.sheetTitle': 'Inspector técnico',
  'studio.designSystem.sheetDescription':
    'Superficie temporal para validar Dialog/Sheet. El inspector final pertenece a M03.5.',
  'studio.designSystem.fieldName': 'Nombre',
  'studio.designSystem.fieldPlaceholder': 'Hero principal',
  'studio.designSystem.closeAction': 'Cerrar panel',
  'studio.designSystem.statesLabel': 'Estados de interfaz',
  'studio.designSystem.typedStatesTechnicalLabel': 'estados tipados visibles',
  'studio.designSystem.tokensLabel': 'Tokens semánticos',
  'studio.designSystem.densityLabel': 'Densidad',
  'studio.designSystem.densityHigh': 'Alta',
  'studio.designSystem.state.initial': 'Inicial',
  'studio.designSystem.state.loading': 'Cargando',
  'studio.designSystem.state.ready': 'Listo',
  'studio.designSystem.state.empty': 'Vacío',
  'studio.designSystem.state.error': 'Error',
  'studio.designSystem.state.disabled': 'Deshabilitado',
  'studio.designSystem.state.saving': 'Guardando',
  'studio.designSystem.state.saved': 'Guardado',
  'studio.designSystem.state.blocked': 'Bloqueado',
  'studio.designSystem.interactionHint':
    'Hover con puntero y focus-visible con Tab usan los mismos tokens semánticos; en móvil se conserva un objetivo táctil mínimo.',
  'studio.designSystem.navigationVocabulary': 'Vocabulario de navegación',
  'studio.designSystem.i18nKeysTechnicalLabel': 'claves i18n',
  'studio.designSystem.helpTitle': 'Ayuda contextual persistente',
  'studio.designSystem.routeLabel': 'Ruta interna',
  'studio.designSystem.internalNotice': 'No representa el editor final.',
} as const);

export type StudioShellMessageKey = keyof typeof studioShellMessagesEs;

export function studioT<Key extends StudioShellMessageKey>(key: Key): (typeof studioShellMessagesEs)[Key] {
  return studioShellMessagesEs[key];
}

export const studioNavigationMessageKeys = Object.freeze([
  'studio.navigation.editor',
  'studio.navigation.screens',
  'studio.navigation.templates',
  'studio.navigation.components',
  'studio.navigation.aiGenerate',
  'studio.navigation.content',
  'studio.navigation.models',
  'studio.navigation.queries',
  'studio.navigation.forms',
  'studio.navigation.automations',
  'studio.navigation.admin',
  'studio.navigation.roles',
  'studio.navigation.media',
  'studio.navigation.extensions',
  'studio.navigation.themes',
  'studio.navigation.preview',
  'studio.navigation.compatibility',
  'studio.navigation.export',
  'studio.navigation.deploy',
  'studio.navigation.help',
  'studio.navigation.settings',
] as const satisfies readonly StudioShellMessageKey[]);
